import src from "IMAGE";
export default { src, width: 600, height: 83, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AGB7gs0QOFN6BydAYgouR2kWO0VcFUNQXh0pQVJNFThqnl0IzXZCI2YAAAAASUVORK5CYII="};
